// eslint-disable-next-line import/extensions
import BaseService from '@/services/base.service';

const initialState = {
  list: []
};

const getters = {
  getLienAddressList: (state) => state.list
};

const actions = {
  fetchLienAddressList: async ({ commit }, { id }) => {
    const tenantService = new BaseService();
    const { data: { result } } = await tenantService.get(`address/list/${id}`);
    commit('setLienAddressList', result);
  },
  // eslint-disable-next-line no-empty-pattern
  handlerLienAddress: async ({}, { uuid, state, id }) => {
    const tenantService = new BaseService();

    if (!id) {
      const { data: { result } } = await tenantService.create(`address/add/${uuid}`, state);

      return result ? Promise.resolve() : Promise.reject();
    }

    const { data: { result } } = await tenantService.create(`address/update/${id}`, state);

    return result ? Promise.resolve() : Promise.reject();
  },
  // eslint-disable-next-line no-empty-pattern
  deleteLienAddress: async ({}, { id }) => {
    const tenantService = new BaseService();
    const { data: { status } } = await tenantService.create(`address/delete/${id}`, {});

    return status === 'success' ? Promise.resolve() : Promise.reject();
  }
};

const mutations = {
  setLienAddressList: (state, list) => {
    state.list = list;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
